﻿import { calculateDistance, getRandomCoordinates, generateGuid, sortFacilitiesBasedOnDistance } from './Helpers'

const facilityNames = ["2 Oak Valley Point", "592 Sommers Trail", "7514 Miller Point", "47 Starling Plaza", "4490 Southridge Lane", "375 Mayfield Lane", "0 Anderson Trail", "5 Pine View Alley", "9364 Summer Ridge Center", "344 Gina Circle", "10 Sullivan Way", "5196 Vidon Parkway", "11 Melby Parkway", "9776 Homewood Trail", "6456 Randy Road", "8163 Raven Lane", "69 Kinsman Court", "48267 Banding Avenue", "1 Porter Avenue", "637 Lakewood Gardens Drive", "99736 Kedzie Parkway", "9 Northwestern Terrace", "72754 Stoughton Lane", "4651 Porter Lane", "4 Muir Street", "47 Mcguire Circle", "603 Sachtjen Plaza", "2 Manufacturers Trail", "6611 Carey Point", "891 Raven Avenue", "098 David Trail", "5 Daystar Junction", "233 Springview Way", "4 Cambridge Place", "40 Rowland Alley", "39 Monica Court", "2590 Manley Street", "2 Moland Trail", "530 Mccormick Junction", "7295 Weeping Birch Point", "5757 2nd Road", "4 Northport Crossing", "8169 Colorado Trail", "5 Fremont Plaza", "5209 Burrows Plaza", "21362 Village Alley", "6 Delaware Pass", "7 Harper Crossing", "2 Reinke Junction", "88 Westridge Crossing", "60812 Hauk Road", "98443 Melrose Junction", "6 Kim Drive", "28 4th Crossing", "08 Daystar Point", "4 Shoshone Circle", "05192 Lindbergh Street", "9 Hoepker Street", "75 Hermina Place", "41796 2nd Pass", "097 David Alley", "3378 Cherokee Point", "2 Mayer Lane", "27 Bunting Point", "48 Talisman Point", "5 Hagan Park", "7614 Starling Point", "8012 Nancy Hill", "9180 Redwing Drive", "0 Garrison Street", "8 Farwell Terrace", "06 Harbort Avenue", "5 South Junction", "2 Rutledge Junction", "31 Declaration Alley", "39 Spenser Park", "9870 Acker Center", "40874 Kenwood Road", "8960 Namekagon Junction", "45645 Kennedy Crossing", "79 Oak Avenue", "6 Nancy Lane", "57512 Dexter Plaza", "88 Pleasure Place", "28378 Warner Court", "5 Brown Terrace", "9 South Drive", "53698 Tomscot Circle", "127 Scott Avenue", "7716 Scott Plaza", "39312 Green Center", "1 Pepper Wood Way", "40452 Bunker Hill Park", "09 Hayes Crossing", "1405 Warbler Road", "1971 Moulton Lane", "5 Dryden Alley", "05 High Crossing Trail", "428 Jenna Parkway", "870 Division Avenue", "4714 Bay Court", "67995 Lillian Circle", "0 Kropf Park", "3504 Lotheville Plaza", "43 Dakota Street", "0628 Miller Hill", "4894 Lillian Road", "920 Bay Parkway", "8179 Bellgrove Lane", "00176 Arkansas Alley", "09012 Huxley Plaza", "362 Elgar Terrace", "580 Summerview Drive", "74 Kipling Park", "72485 Michigan Circle", "0 Scott Center", "1 Bellgrove Terrace", "03815 Grim Circle", "639 Evergreen Way", "08 Sunfield Plaza", "64 Ronald Regan Point", "523 Jay Court", "8711 Iowa Hill", "11048 Victoria Place", "6 Dahle Drive", "0 Center Trail", "670 Holy Cross Crossing", "3 John Wall Way", "4423 Schurz Pass", "43268 Sugar Place", "96538 Surrey Court", "57 Center Hill", "065 Lighthouse Bay Street", "30 Green Court", "7 Thackeray Road", "858 Kropf Crossing", "6194 Michigan Avenue", "0 Westridge Plaza", "54 Valley Edge Place", "12 Kingsford Crossing", "69779 Dennis Alley", "612 Main Place", "915 Del Mar Place", "5 Moland Court", "94 Haas Park", "5 Rowland Court", "290 Lien Road", "177 Ohio Way", "61872 Dapin Place", "24 Orin Hill", "62723 Holy Cross Park", "4347 Elka Drive", "67673 Ronald Regan Road", "1 Jenna Court", "34922 Rigney Hill", "71849 Linden Lane", "00 Gale Terrace", "4 Monument Parkway", "34 Browning Center", "8148 Brentwood Parkway", "3582 Clemons Avenue", "97 Service Park", "223 Bunting Crossing", "27 Di Loreto Parkway", "639 Harper Circle", "0 Ilene Point", "1 Lighthouse Bay Terrace", "15 Spohn Place", "4 Rieder Park", "26 Loeprich Place", "5637 Maple Wood Alley", "1306 Banding Terrace", "99 Jenna Way", "51157 Hoepker Street", "332 6th Point", "51569 Bay Plaza", "0 Briar Crest Lane", "1 Killdeer Terrace", "60044 Warner Park", "794 Hagan Plaza", "6120 Washington Point", "195 Summer Ridge Lane", "4 Truax Circle", "9807 Pennsylvania Hill", "50935 Debs Junction", "63942 Burrows Avenue", "4426 Forster Drive", "53 Lawn Place", "0153 Meadow Valley Parkway", "0 Commercial Alley", "51830 Tennyson Plaza", "9 Amoth Parkway", "3646 Pankratz Parkway", "794 Algoma Drive", "5624 Scofield Plaza", "5460 Merchant Place", "6746 Schiller Street", "4698 Kennedy Pass", "481 Anderson Circle", "96227 Bowman Plaza"];

const facilityServices = [
  { name: 'Car wash', type: 'carWash' },
  { name: 'Electric charging', type: 'electricCharging' }, 
  { name: 'Shoe polish', type: 'shoePolish' }, 
  { name: 'Elevator', type: 'elevator' }, 
  { name: 'Indoor parking', type: 'indoorParking' }, 
  { name: 'Extra service 1', type: 'extraService1' }, 
  { name: 'Extra service 2', type: 'extraService2' }, 
  { name: 'Online bookable', type: 'onlineBookable' }, 
  { name: 'Long Term Rent', type: 'longTermRent' }, 
  { name: 'Product: 7x24', type: 'product7x24' }, 
  { name: 'Product: 5x24', type: 'product5x24' }, 
  { name: 'Product: OfficeHours', type: 'productOfficeHours' }, 
  { name: 'Product: Weekend', type: 'productWeekend' }, 
]

function generateFaciliesList(amount, selectedPosition, position = { lat: 59.329, lng: 18.068 }) {
  const searchedGeolocation = selectedPosition ?? position;
  const timerName = amount + ' facilies generated (and sorted) in';

  console.time(timerName);
  const newArray = [];

  for (let i = 0, l = amount; i < l; i++) {
    const randomGeolocation = getRandomCoordinates((position.lat - 0.1), (position.lat + 0.1), (position.lng - 0.1), (position.lng + 0.1));
    const name = facilityNames[Math.floor(Math.random() * facilityNames.length)];
    const services = facilityServices.sort(() => Math.random() - 0.5).slice(0, 5).map((service) => service.type);

    newArray.push({
      uid: generateGuid(),
      name,
      address: { 
        street: 'Fake street 1', 
        postCode: '123 45', 
        city: 'Fake city', 
        marker: { 
          coordinates: [
            randomGeolocation.lng, 
            randomGeolocation.lat, 
          ]
        }, 
        distance: calculateDistance(
          { latitude: searchedGeolocation.lat, longitude: searchedGeolocation.lng }, 
          { latitude: randomGeolocation.lat, longitude: randomGeolocation.lng }, 
          { unit: 'km' }
        ),
      }, 
      openUntil: 'XX pm', 
      hourlyPrice: 'XXX sek/h', 
      services, 
      url: `#${i}`
    });
  }

  console.timeEnd(timerName);

  return sortFacilitiesBasedOnDistance(newArray);
}

export const mockedFacilities = (position, selectedPosition) => generateFaciliesList(100, selectedPosition, position);
export const mockedStockholm = {
	"Data": [
		{
			"uid": "SE-112",
			"name": "Citygaraget",
			"address": {
				"street": "Mäster Samuelsgatan",
				"number": "61",
				"postCode": "11121",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06087,
						59.3323
					]
				},
				"distance": 0.00813000484870509
			},
			"url": "/link/79aa50235ebc4a03ba03b0ad6225c671.aspx?epslanguage=en",
			"openstatus": "",
			"services": [
				"electricChargingPoint",
				"information",
				"shoePolisher",
				"elevator",
				"jumpLeads",
				"toilet",
				"CCTV",
				"carWash",
				"newspaperMagazines",
				"serviceCar",
				""
			],
			"rentalInstructions": null
		},
		{
			"uid": "SE-199",
			"name": "Zenit",
			"address": {
				"street": "Klara Norra Kyrkogata",
				"number": "14",
				"postCode": "11122",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.0596,
						59.33286
					]
				},
				"distance": 0.08800496201404441
			},
			"url": "/link/14afde573e284294ad1bf52043cb89a2.aspx?epslanguage=en",
			"openstatus": "",
			"services": [
				"electricChargingPoint",
				"shoePolisher",
				"elevator",
				"CCTV",
				"surveillanceAtNight",
				"creditCardPayment",
				"serviceCar",
				"motorcycleParking",
				""
			],
			"rentalInstructions": null
		},
		{
			"uid": "SE-184",
			"name": "Klarabergsgatan",
			"address": {
				"street": "Klara Östra Kyrkogata",
				"number": "7",
				"postCode": "11152",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06208,
						59.33181
					]
				},
				"distance": 0.09529146763444764
			},
			"url": "/link/73956da9189a44a19d6e4a9683092013.aspx?epslanguage=en",
			"openstatus": "",
			"services": [
				"electricChargingPoint",
				"CCTV",
				"surveillanceAtNight",
				"carWash",
				"creditCardPayment",
				"serviceCar",
				""
			],
			"rentalInstructions": null
		},
		{
			"uid": "SE-92530",
			"name": "Klara Östra Kyrkogata 12",
			"address": {
				"street": "Klara Östra Kyrkogata",
				"number": "12",
				"postCode": "11152",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06233,
						59.33169
					]
				},
				"distance": 0.1146739226298134
			},
			"url": "/link/499dc9e4e7d3452295992b247d4eef1a.aspx?epslanguage=en",
			"openstatus": "",
			"services": [],
			"rentalInstructions": null
		},
		{
			"uid": "SE-4345",
			"name": "Bryggargatan 12A",
			"address": {
				"street": "Bryggargatan",
				"number": "12 A",
				"postCode": "11121",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.05851,
						59.33281
					]
				},
				"distance": 0.13746161822911615
			},
			"url": "/link/fa60252ad443402cbcde014f97fb6be7.aspx?epslanguage=en",
			"openstatus": "",
			"services": [],
			"rentalInstructions": null
		},
		{
			"uid": "SE-91916",
			"name": "Gamla Brogatan 35",
			"address": {
				"street": "Gamla Brogatan",
				"number": "35",
				"postCode": "11120",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.05589,
						59.33282
					]
				},
				"distance": 0.2805192748934539
			},
			"url": "/link/c4bbfb76fc70411aac8a934753c40724.aspx?epslanguage=en",
			"openstatus": "",
			"services": [],
			"rentalInstructions": null
		},
		{
			"uid": "PTF-11601992438447",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Ab Svensk Filmindustri 9640",
				"number": null,
				"postCode": "16986",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11601992701155",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Ab Svensk Filmindustri 4804",
				"number": null,
				"postCode": "16986",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11601992728152",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "??lgpassgatan 4273",
				"number": null,
				"postCode": "11545",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11601992823330",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Ahlsellv?�gen 884",
				"number": null,
				"postCode": "11543",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11601992855333",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Arbetargatan 274",
				"number": null,
				"postCode": "11245",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11601994028096",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Arsenalsgatan 3158",
				"number": null,
				"postCode": "11147",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11602006719970",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Artillerigatan 3965",
				"number": null,
				"postCode": "11451",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11602006975970",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Fj�rde Bass�ngv�gen 3023",
				"number": null,
				"postCode": "11541",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41602007832290",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Disponentgatan 2889",
				"number": null,
				"postCode": "11262",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41602008613431",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "�rsta�ngsv�gen 422",
				"number": null,
				"postCode": "11775",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41602009125431",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Jakobs Torg 4512",
				"number": null,
				"postCode": "11152",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-121602010884820",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "L�nga Raden 8566",
				"number": null,
				"postCode": "11149",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41602012061680",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Porjusv�gen 8891",
				"number": null,
				"postCode": "11543",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-231602014826755",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Roslagstullsbacken 1875",
				"number": null,
				"postCode": "11421",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-451602015670817",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Maria Sandels Gr�nd 4537",
				"number": null,
				"postCode": "11269",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-161602088763312",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Hagagatan 8127",
				"number": null,
				"postCode": "11348",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-221602088763281",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Hagagatan 1790",
				"number": null,
				"postCode": "11347",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51602088490593",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "�stermalmsgatan 3119",
				"number": null,
				"postCode": "11459",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-11603280366893",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Ab Svensk Filmindustri 7586",
				"number": null,
				"postCode": "16986",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277950360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Timmermansgatan 8991",
				"number": null,
				"postCode": "11825",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277949860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tideliusgatan 8802",
				"number": null,
				"postCode": "11869",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277949360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Thorildsv�gen 4534",
				"number": null,
				"postCode": "11243",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277948860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Thorildsplan 4237",
				"number": null,
				"postCode": "11243",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277948360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Textilgatan 1578",
				"number": null,
				"postCode": "12030",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277947860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Terminalslingan 8997",
				"number": null,
				"postCode": "11164",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277947360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tengdahlsgatan 8765",
				"number": null,
				"postCode": "11648",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277946860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tengdahlsgatan 3941",
				"number": null,
				"postCode": "11647",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277946360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tengdahlsgatan 9933",
				"number": null,
				"postCode": "11641",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277945860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tempeltrappan 4787",
				"number": null,
				"postCode": "11333",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277945360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Telegrafgr�nd 3218",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277944860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Teknologgatan 1449",
				"number": null,
				"postCode": "11360",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277944360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Teknikringen 1748",
				"number": null,
				"postCode": "11428",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277943860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rlunden 6441",
				"number": null,
				"postCode": "11359",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277943360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rlunden 8408",
				"number": null,
				"postCode": "11161",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277942860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rgatan 7321",
				"number": null,
				"postCode": "11359",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277942360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rgatan 5799",
				"number": null,
				"postCode": "11358",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277941860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rgatan 597",
				"number": null,
				"postCode": "11329",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277941360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rgatan 1661",
				"number": null,
				"postCode": "11161",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277940860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegn�rgatan 6635",
				"number": null,
				"postCode": "11140",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277940360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegelviksslingan 1553",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277939860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegelviksplan 6502",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277939360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegelviksgatan 9678",
				"number": null,
				"postCode": "11647",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277938860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegelviksgatan 913",
				"number": null,
				"postCode": "11641",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277938360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegeluddsv�gen 1186",
				"number": null,
				"postCode": "11560",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277937860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegeluddsv�gen 3324",
				"number": null,
				"postCode": "11541",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277937360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegeluddsv�gen 2131",
				"number": null,
				"postCode": "11540",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277936860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegeluddsv�gen 2841",
				"number": null,
				"postCode": "11538",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277936360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegeluddsv�gen 1159",
				"number": null,
				"postCode": "11528",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277935860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tegelbacken 1845",
				"number": null,
				"postCode": "11152",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277935360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Teatergatan 309",
				"number": null,
				"postCode": "11148",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277934860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Taxgatan 8534",
				"number": null,
				"postCode": "11545",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277934360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tavastgatan 9368",
				"number": null,
				"postCode": "11824",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277933860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tavastgatan 5585",
				"number": null,
				"postCode": "11820",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277933360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Taptogatan 2026",
				"number": null,
				"postCode": "11526",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277932860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tantogatan 4683",
				"number": null,
				"postCode": "11867",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277932360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Tantogatan 9202",
				"number": null,
				"postCode": "11842",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277931860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sysslomansgatan 7177",
				"number": null,
				"postCode": "11241",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277931360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Swedenborgsgatan 9045",
				"number": null,
				"postCode": "11848",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277930860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Swedenborgsgatan 341",
				"number": null,
				"postCode": "11827",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277930360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svensksundsv�gen 1475",
				"number": null,
				"postCode": "11149",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277929860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svenska Travsportens Centralf� 660",
				"number": null,
				"postCode": "16189",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277929360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svensk Pingstmission 4138",
				"number": null,
				"postCode": "14199",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277928860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sven Vintappares Gr�nd 8805",
				"number": null,
				"postCode": "11127",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277928360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sven Rinmans Gata 1119",
				"number": null,
				"postCode": "11237",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277927860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svedbergsstigen 2393",
				"number": null,
				"postCode": "11258",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277927360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svedbergsplan 5598",
				"number": null,
				"postCode": "11258",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277926860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sveav�gen 8120",
				"number": null,
				"postCode": "11359",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277926360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sveav�gen 9497",
				"number": null,
				"postCode": "11350",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277925860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sveav�gen 3176",
				"number": null,
				"postCode": "11349",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277925360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sveav�gen 9845",
				"number": null,
				"postCode": "11346",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277924860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sveav�gen 4060",
				"number": null,
				"postCode": "11157",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277924360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sveav�gen 5731",
				"number": null,
				"postCode": "11134",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277923860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svarvargatan 4826",
				"number": null,
				"postCode": "11249",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277923360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svartmangatan 8606",
				"number": null,
				"postCode": "11129",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277922860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svartensgatan 154",
				"number": null,
				"postCode": "11620",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277922360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Svante Arrhenius V�g 4731",
				"number": null,
				"postCode": "11418",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277921860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Surbrunnsgatan 7893",
				"number": null,
				"postCode": "11427",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277921360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Surbrunnsgatan 9301",
				"number": null,
				"postCode": "11348",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277920860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Surbrunnsgatan 1084",
				"number": null,
				"postCode": "11327",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277920360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sundstabacken 5053",
				"number": null,
				"postCode": "12030",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277919860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Styrmansgatan 9612",
				"number": null,
				"postCode": "11460",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277919360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Styrmansgatan 8578",
				"number": null,
				"postCode": "11454",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277918860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Styrbordsgatan 2137",
				"number": null,
				"postCode": "12065",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277918360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Styckjunkargatan 2297",
				"number": null,
				"postCode": "11435",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277917860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stureplan 9583",
				"number": null,
				"postCode": "11435",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277917360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stureplan 3638",
				"number": null,
				"postCode": "11145",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277916860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stureparken 4712",
				"number": null,
				"postCode": "11426",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277916360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sturehillsv�gen 3423",
				"number": null,
				"postCode": "11756",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277915860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sturegatan 2031",
				"number": null,
				"postCode": "11436",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277915360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sturegatan 4569",
				"number": null,
				"postCode": "11435",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277914860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Studentbacken 1018",
				"number": null,
				"postCode": "11557",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277914360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stuckat�rv�gen 665",
				"number": null,
				"postCode": "11759",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277913860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strykerskev�gen 2749",
				"number": null,
				"postCode": "11264",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277913360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Str�msborgsbron 2859",
				"number": null,
				"postCode": "11128",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277912860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Str�mparterren 5260",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277912360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Str�mgatan 6715",
				"number": null,
				"postCode": "11152",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277911860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strindbergsgatan 7581",
				"number": null,
				"postCode": "11553",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277911360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strindbergsgatan 8759",
				"number": null,
				"postCode": "11531",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277910860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strandv�gskajen 5978",
				"number": null,
				"postCode": "11456",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277910360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strandv�gen 6785",
				"number": null,
				"postCode": "11523",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277909860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strandv�gen 3517",
				"number": null,
				"postCode": "11456",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277909360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strandv�gen 286",
				"number": null,
				"postCode": "11451",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277908860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stranden 1159",
				"number": null,
				"postCode": "11770",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277908360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Strandbergsgatan 5374",
				"number": null,
				"postCode": "11251",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277907860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Str�lgatan 659",
				"number": null,
				"postCode": "11263",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277907360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stortorget 5285",
				"number": null,
				"postCode": "11129",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277906860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Storsk�rsgatan 8383",
				"number": null,
				"postCode": "11529",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277906360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Storkyrkobrinken 6598",
				"number": null,
				"postCode": "11128",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277905860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Storgatan 9125",
				"number": null,
				"postCode": "11523",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277905360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Storgatan 761",
				"number": null,
				"postCode": "11455",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277904860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Storgatan 9664",
				"number": null,
				"postCode": "11451",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277904360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Storgatan 7468",
				"number": null,
				"postCode": "11444",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277903860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stor�ngsv�gen 5161",
				"number": null,
				"postCode": "11542",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277903360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stor�ngstorget 2557",
				"number": null,
				"postCode": "11544",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277902860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stor�ngskroken 8075",
				"number": null,
				"postCode": "11542",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277902360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stor�ngsgatan 7810",
				"number": null,
				"postCode": "11544",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277901860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stora Skuggans V�g 7875",
				"number": null,
				"postCode": "11542",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277901360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stora Nygatan 3569",
				"number": null,
				"postCode": "11127",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277900860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stora Mejtens Gr�nd 4034",
				"number": null,
				"postCode": "11635",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277900360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stora Hoparegr�nd 9282",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277899860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stora Gr�munkegr�nd 7305",
				"number": null,
				"postCode": "11127",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277899360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stora Essingep�farten 9355",
				"number": null,
				"postCode": "11264",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277898860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stigbergsgatan 9403",
				"number": null,
				"postCode": "11628",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277898360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stiernhielmsv�gen 6126",
				"number": null,
				"postCode": "11244",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277897860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stickelb�rsv�gen 4566",
				"number": null,
				"postCode": "11423",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277897360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stensh�llsv�gen 9699",
				"number": null,
				"postCode": "11264",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277896860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stenkullav�gen 6972",
				"number": null,
				"postCode": "11265",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277896360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stenbocksgatan 3463",
				"number": null,
				"postCode": "11430",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277895860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Starr�ngsringen 5349",
				"number": null,
				"postCode": "11550",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277895360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stapelgatan 5686",
				"number": null,
				"postCode": "12071",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277894860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stallgatan 8724",
				"number": null,
				"postCode": "11148",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277894360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stagneliusv�gen 8751",
				"number": null,
				"postCode": "11259",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277893860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stagneliusv�gen 7802",
				"number": null,
				"postCode": "11257",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277893360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Staffan Sasses Gr�nd 3637",
				"number": null,
				"postCode": "11131",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277892860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadshagsv�gen 822",
				"number": null,
				"postCode": "11250",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277892360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadshagsplan 5580",
				"number": null,
				"postCode": "11250",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277891860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadshagens Idrottsv�g 9931",
				"number": null,
				"postCode": "11250",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277891360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadsg�rdsleden 359",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277890860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadsg�rdshamnen 7191",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277890360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadsg�rdens Kajplatser 58",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277889860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Stadsg�rden 2703",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277889360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Spektens Gr�nd 7323",
				"number": null,
				"postCode": "11129",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277888860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sonja Kovalevskys Gata 7085",
				"number": null,
				"postCode": "11365",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277888360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Solnav�gen 5361",
				"number": null,
				"postCode": "11365",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277887860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sollidsbacken 7883",
				"number": null,
				"postCode": "11521",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277887360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Solkraftsv�gen 4125",
				"number": null,
				"postCode": "13570",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277886860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Solgr�nd 7136",
				"number": null,
				"postCode": "11129",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277886360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sofiebergsv�gen 8665",
				"number": null,
				"postCode": "11733",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277885860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sofiagatan 5297",
				"number": null,
				"postCode": "11640",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277885360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Riddarholmshamnen 6458",
				"number": null,
				"postCode": "11128",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277884860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Kajen 4445",
				"number": null,
				"postCode": "11541",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277884360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Hamnv�gen 806",
				"number": null,
				"postCode": "11541",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277883860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Fiskartorpsv�gen 2314",
				"number": null,
				"postCode": "11433",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277883360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Dryckesgr�nd 8816",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277882860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Brob�nken 9195",
				"number": null,
				"postCode": "11149",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277882360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Blasieholmshamnen 257",
				"number": null,
				"postCode": "11148",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277881860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Benickebrinken 8034",
				"number": null,
				"postCode": "11131",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277881360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Bass�ngkajen 1473",
				"number": null,
				"postCode": "11541",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277880860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Bankogr�nd 798",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277880360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Agnegatan 3997",
				"number": null,
				"postCode": "11229",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277879860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dra Agnegatan 1234",
				"number": null,
				"postCode": "11221",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277879360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dert�ljev�gen 6858",
				"number": null,
				"postCode": "11743",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277878860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermannagatan 7444",
				"number": null,
				"postCode": "11666",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277878360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermannagatan 1419",
				"number": null,
				"postCode": "11665",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277877860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermannagatan 1389",
				"number": null,
				"postCode": "11640",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277877360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermannagatan 8545",
				"number": null,
				"postCode": "11623",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277876860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermalmstorg 9990",
				"number": null,
				"postCode": "11820",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277876360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermalmstorg 4405",
				"number": null,
				"postCode": "11645",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277875860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermalmsall�n 1273",
				"number": null,
				"postCode": "11863",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277875360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�dermalmsall�n 6380",
				"number": null,
				"postCode": "11828",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277874860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�derhallarna 9220",
				"number": null,
				"postCode": "11872",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277874360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�der M�larstrands Kajplatser 1107",
				"number": null,
				"postCode": "11825",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277873860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�der M�larstrands Kajplatser 2232",
				"number": null,
				"postCode": "11820",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277873360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�der M�larstrand 1404",
				"number": null,
				"postCode": "11825",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277872860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�der M�larstrand 9521",
				"number": null,
				"postCode": "11820",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277872360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�der M�larstrand 6681",
				"number": null,
				"postCode": "11731",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277871860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "S�der M�larstrand 3515",
				"number": null,
				"postCode": "11730",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277871360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sockerbruksgr�nd 3656",
				"number": null,
				"postCode": "11842",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277870860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Snoilskyv�gen 6936",
				"number": null,
				"postCode": "11254",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277870360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Snipkroken 1552",
				"number": null,
				"postCode": "11264",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277869860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Snickarbacken 4381",
				"number": null,
				"postCode": "11139",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277869360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Smedsuddsv�gen 1565",
				"number": null,
				"postCode": "11235",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277868860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Smedsbacksgatan 5851",
				"number": null,
				"postCode": "11539",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277868360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sm�landsgatan 9355",
				"number": null,
				"postCode": "11146",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277867860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Smala Gr�nd 8567",
				"number": null,
				"postCode": "11139",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277867360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Slussplan 9558",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277866860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Slupskjulsv�gen 8824",
				"number": null,
				"postCode": "11149",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277866360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Slottsbacken 6601",
				"number": null,
				"postCode": "11130",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-41603277865860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sl�jdgatan 6143",
				"number": null,
				"postCode": "11157",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277865360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Slipgatan 4857",
				"number": null,
				"postCode": "11739",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-21603277864860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Sl�ttervallsgatan 53",
				"number": null,
				"postCode": "11544",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277864360",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Skutskepparv�gen 2279",
				"number": null,
				"postCode": "11733",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-61603277863860",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Skrubbasandsv�gen 3820",
				"number": null,
				"postCode": "13570",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		},
		{
			"uid": "PTF-51603277863361",
			"name": "Perftest Parking Facility",
			"address": {
				"street": "Skr�ddargr�nd 1199",
				"number": null,
				"postCode": "11127",
				"city": "Stockholm",
				"country": "Sweden",
				"countryCode": "SE",
				"marker": {
					"type": "Point",
					"coordinates": [
						18.06324,
						59.334591
					]
				},
				"distance": 0.2901216988273319
			},
			"url": "",
			"openstatus": "",
			"services": [],
			"rentalInstructions": ""
		}
	]
}